import type { RefObject } from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { TableRef } from './Table/Table';

type NavigationButtonsProps = {
  tableRef: RefObject<TableRef | null>;
  disabled?: boolean;
};

export default function NavigationButtons(
  { tableRef, disabled = false }: NavigationButtonsProps
) {
  return (
    <div
      className="position-absolute d-flex flex-column gap-1 p-2"
      style={{
        top: 0,
        left: '100%',
        marginLeft: '-6rem',
        zIndex: 5000,
      }}
    >
      <ButtonGroup vertical>
        <Button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          disabled={disabled}
        >
          <i className="bi bi-chevron-double-up"></i>
        </Button>

        <Button
          onClick={() => {
            window.scrollBy({ top: -200, behavior: 'smooth' });
            tableRef.current?.setRow(-1);
          }}
          disabled={ disabled }
        >
          <i className="bi bi-chevron-up"></i>
        </Button>
        <Button
          onClick={() => {
            window.scrollBy({ top: 200, behavior: 'smooth' });
            tableRef.current?.setRow(1);
          }}
          disabled={disabled}
        >
          <i className="bi bi-chevron-down"></i>
        </Button>

        <Button
          onClick={() =>
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth',
            })
          }
          disabled={ disabled }
        >
          <i className="bi bi-chevron-double-down"></i>
        </Button>
      </ButtonGroup>
    </div>
        );
}
